export interface SearchListingConfig {
    /** Full-span virtualized results listing replacing paged navigation. */
    virtualization: boolean;
    /** List-aligned browser scrollbar; only effective with virtualization. */
    customScrollbar: boolean;
    /** Shared fixed-height project cards replacing the legacy search cards. */
    cardUnification: boolean;
}

const ROLLED_OUT_CONFIG: SearchListingConfig = {
    virtualization: true,
    customScrollbar: true,
    cardUnification: true,
};

/**
 * The rolled-out search-listing configuration.
 */
export function useSearchListingConfig(): SearchListingConfig {
    return ROLLED_OUT_CONFIG;
}
